(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbs-assessment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dbs-assessment')) {
 customElements.define('dbs-assessment', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.fields = [...this.querySelectorAll('.dbs-field')];
   this.total = Math.ceil(this.fields.length / 2);
   this.step = 0;
   this.actions = this.querySelector('.dbs-assessment-actions');
   this.nextButton = this.querySelector('[data-next]');
   this.backButton = this.querySelector('[data-back]');
   this.summary = this.querySelector('[data-summary]');
   if (!this.fields.length) return;
   this.actions.hidden = false;
   this.nextButton.addEventListener('click', () => this.advance());
   this.backButton.addEventListener('click', () => { this.step = Math.max(0, this.step - 1); this.draw(true); });
   this.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); this.advance(); } });
   this.draw(false);
  }
  advance() {
   const current = this.fields.slice(this.step * 2, this.step * 2 + 2);
   for (const field of current) { if (!field.querySelector('input,select').reportValidity()) return; }
   this.step = Math.min(this.total, this.step + 1);
   this.draw(true);
  }
  draw(moveFocus) {
   this.fields.forEach((field, index) => { field.hidden = Math.floor(index / 2) !== this.step; });
   const done = this.step === this.total;
   this.summary.hidden = !done;
   this.nextButton.hidden = done;
   this.backButton.hidden = this.step === 0;
   this.nextButton.textContent = this.step === this.total - 1 ? this.dataset.review : this.dataset.next;
   this.querySelector('[data-progress-label]').textContent = this.dataset.stepLabel.replace('{current}', Math.min(this.step + 1, this.total)).replace('{total}', this.total);
   this.querySelector('[data-progress-bar]').style.width = `${Math.min((this.step + 1) / this.total, 1) * 100}%`;
   if (done) {
    const list = this.summary.querySelector('dl'); list.replaceChildren();
    this.fields.forEach(field => { const dt = document.createElement('dt'); const dd = document.createElement('dd'); dt.textContent = field.querySelector('label').textContent; dd.textContent = field.querySelector('input,select').value; list.append(dt, dd); });
   }
   if (moveFocus) (done ? this.summary : this.fields[this.step * 2].querySelector('input,select')).focus();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbs-calculator"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dbs-revenue-calculator'))customElements.define('dbs-revenue-calculator',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.inputs=[...this.querySelectorAll('[data-calc]')];
  this.addEventListener('input',()=>this.update());
  this.querySelectorAll('[data-drinks]').forEach(button=>button.addEventListener('click',()=>{this.querySelector('[data-calc="drinks"]').value=button.dataset.drinks;this.update();}));
  this.update();
 }
 update(){
  const valid=this.inputs.every(input=>input.value!==''&&input.validity.valid&&Number.isFinite(Number(input.value)));
  const values=Object.fromEntries(this.inputs.map(input=>[input.dataset.calc,Number(input.value)]));
  this.querySelector('[data-calc-error]').hidden=valid;
  const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0});
  const monthly=values.drinks*values.price*values.days;
  this.querySelector('[data-monthly]').textContent=valid?money.format(monthly):'—';
  this.querySelector('[data-annual]').textContent=valid?money.format(monthly*12):'—';
  this.querySelectorAll('[data-drinks]').forEach(button=>{const selected=valid&&Number(button.dataset.drinks)===values.drinks;button.setAttribute('aria-pressed',String(selected));button.classList.toggle('dbs-button--quiet',!selected);});
  document.querySelectorAll('[data-calculator-assumptions]').forEach(input=>{input.value=valid?`${values.drinks} drinks/day; USD ${values.price}/drink; ${values.days} days/month; illustrative gross sales USD ${monthly.toFixed(2)}/month before costs; not a profit forecast`:'';});
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbs-office-fit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dbs-office-fit'))customElements.define('dbs-office-fit',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.people=this.querySelector('[data-people]');
  const params=new URLSearchParams(location.search);
  this.querySelectorAll('[data-utm]').forEach(input=>input.value=(params.get(input.dataset.utm)||'').slice(0,200));
  this.addEventListener('input',()=>this.update());
  this.closest('form').addEventListener('submit',()=>this.update());
  this.update();
 }
 update(){
  const valid=this.people.value!==''&&this.people.validity.valid;
  const drinks=Number(this.querySelector('input[type="radio"]:checked').value);
  const total=Number(this.people.value)*drinks;
  this.querySelector('[data-result]').hidden=!valid;
  this.querySelector('[data-email-panel]').hidden=!valid;
  this.querySelector('[data-high]').hidden=!valid||total<30;
  this.querySelector('[data-low]').hidden=!valid||total>=30;
  this.querySelector('[data-summary]').textContent=valid?this.dataset.summary.replace('{total}',total.toLocaleString('en-US')):'';
  this.querySelector('[data-total]').value=valid?String(total):'';
  this.querySelector('[data-fit]').value=valid?(total>=30?'30+ drinks/day; preliminary demand fit, location and setup unconfirmed':'Under 30 drinks/day; review alternative coffee setup'):'';
 }
});

  } catch(e) { console.error(e); }
})();
})();
